<template>
  	<div class="instance-detail">
		<div class="jc-page-header">
			<el-page-header show-back-icon :title="$t('privateNetInstance.cps')" @back="goBack" class="relative">
				<template slot="content">
					<span class="long-name" :title="detail.name">
						{{detail.name}}
					</span>						
					<div :class="getClassByStatue(detail.status)" class="jc-status-pl">
						<span class="icon-status icon-stopped icon-run"
							v-if="detail.status !== 'running' && detail.status !== 'stopped'">
						</span>
						{{ transFormStatusName(detail.status) }}
					</div>
					<!-- 帮助文档及操作 -->
					<div class="jc-list__header--right jc-box-action">
						<a :href="Config.CPS_HELP_URL" target="_blank">
							{{ $t('privateNetInstance.helpDoc') }}
						</a>
						<drop-down-operation :buttonTitle="$t('privateNetInstance.operate')"
							:operations='ops'
							@clickSelectItem="clickOperate">
						</drop-down-operation>
					</div>
				</template>
			</el-page-header>
		</div>
		<div class="jc-page-content">
			<el-tabs
				ref="pageTabs"
				type="border-card" 
				@tab-click="changeTab" 
				v-model="tabName">
				<!-- tab:资源信息 -->
				<el-tab-pane 
					:label="$t('privateNetInstance.sourceInfo')" 
					name="sourceInfo"
					:disabled="tabName==='sourceInfo'">
					<!-- 基本信息 -->
				  	<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('privateNetInstance.baseInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form class="base-info-list" @submit.stop.prevent>
								<el-row :gutter="20">
									<!--ID-->
									<el-col :span="8">
										<el-form-item :label="$t('privateNetInstance.id') | withColon">
										  	<span>{{ detail.instanceId }}</span>
										  	<copy-value :copyVal="detail.instanceId"></copy-value>
										</el-form-item>
									</el-col>
									<!--名称-->
								  	<el-col :span="8">
										<el-form-item :label="$t('privateNetInstance.name') | withColon"
											class="edit-jc-form">
										  	<span :title="detail.name" class="instance-name">{{ detail.name }}</span>
										  	<el-popover ref="editValue"
												trigger="click"
												:visible-arrow="false"
												:offset="0"
												placement="left-start"
												:width="300"
												v-if="showEditName"
												:value="showEditName">
												<edit-value :inputVal="detail.name"
													v-if="showEditName"
													@sureEdit="editName"
													:inputValRule="rules.name"
													:showEditDes.sync="showEditName"
													:popTitle="$t('privateNetwork.editName')">
												</edit-value>
										  	</el-popover>
										  	<el-button type="text" icon="jc-icon-edit"
												@click="showEditName = true"
												v-popover:editValue>
										  	</el-button>
										  	<div class="jc-colude-mask" v-if="showEditName"></div>
										</el-form-item>
								  	</el-col>
								  	<!--地域-->
								  	<el-col :span="8">
										<el-form-item 
											:label="$t('privateNetInstance.region') | withColon">
											<span>{{ regions[detail.region] }}</span>
										</el-form-item>
								  	</el-col>
								  	<!--可用区-->
								  	<el-col :span="8">
										<el-form-item 
											:label="$t('privateNetInstance.valArea') | withColon">
											<span>{{ regions[detail.az] }}</span>
										</el-form-item>
								  	</el-col>
									<!-- 机柜编码 -->
									<el-col :span="8">
										<el-form-item 
											:label="$t('detail.text.cabinet') | withColon">
											<span>{{ detail.cabinet | maybeEmpty  }}</span>
										</el-form-item>
								  	</el-col>
								  	<!--标签-->
								  	<el-col :span="8">
										<el-form-item 
											:label="$t('listPage.text.tags') | withColon"
											class="edit-jc-form">
										  	<span class="instance-name" 
											  	:title="detail.tagPairs | maybeEmpty">
												{{ detail.tagPairs | maybeEmpty }}
										  	</span>
										</el-form-item>
								  	</el-col>
								  	<!--实例删除保护-->
								  	<el-col :span="8">
										<el-form-item 
											:label="$t('privateNetInstance.deleteProtect') | withColon"
											class="edit-jc-form">
										  	<span class="instance-name">
												{{ DeleteProtectStatusConstant[detail.removeProtect] | maybeEmpty }}
										  	</span>
										</el-form-item>
								  	</el-col>
								  	<!--Agent状态-->
								  	<el-col :span="8">
										<agent-status :data="!parseInt(detail.agentStatus,10)"/>
								  	</el-col>
								  	<!--描述-->
								  	<el-col :span="8">
										<el-form-item 
											:label="$t('privateNetInstance.description')| withColon"
											class="edit-jc-form">
										  	<span :title="detail.description" class="instance-name">
												{{ detail.description }}
										  	</span>
										  	<el-popover ref="editDes"
												trigger="click"
												:visible-arrow="false"
												:offset="0"
												placement="left-start"
												:width="300"
												v-if="showEditDes"
												:value="showEditDes">
												<edit-value :inputVal="detail.description"
													v-if="showEditDes"
													@sureEdit="editDes"
													:type="'textarea'"
													:inputValRule="rules.description"
													:showEditDes.sync="showEditDes"
													:popTitle="$t('privateNetwork.editDescription')">
												</edit-value>
										  	</el-popover>
										  	<el-button type="text" icon="jc-icon-edit"
												@click="showEditDes = true"
												v-popover:editDes>
										  	</el-button>
										  	<div class="jc-colude-mask" v-if="showEditDes"></div>
										</el-form-item>
								  	</el-col>
								</el-row>
							</el-form>
						</div>
				  	</div>
					<el-divider></el-divider>
				  	<!-- 计费信息 -->
				  	<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('eip.text.billInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form class="base-info-list" @submit.stop.prevent>
								<el-row :gutter="20">
								  	<!--计费类型-->
								  	<el-col :span="8">
										<el-form-item 
											:label="$t('privateNetInstance.chargeType') | withColon">
											<span v-if="detail.charge && detail.charge.chargeMode">
												{{ transformChargeMode(detail.charge.chargeMode) }}
											</span>
										  	<span v-else>{{ '--' }}</span>
										</el-form-item>
								  	</el-col>
								  	<!--创建时间-->
								  	<el-col :span="8">
										<el-form-item 
											:label="$t('privateNetInstance.createTime') | withColon">
										  	<span v-if="detail.charge && detail.charge.chargeStartTime">
												{{ detail.charge.chargeStartTime }}
										  	</span>
										  	<span v-else>{{ '--' }}</span>
										</el-form-item>
								  	</el-col>
								  	<!--到期时间-->
								  	<el-col :span="8" 
								  		v-if="detail.chargeMode === 	ChargeModeConstant.PREPAID_BY_DURATION">
										<el-form-item 
											:label="$t('privateNetInstance.expireTime') | withColon">
										  	<span v-if="detail.charge && detail.charge.chargeExpiredTime">
												{{ detail.charge.chargeExpiredTime }}
										  	</span>
										  	<span v-else> {{ '--' }}</span>
										</el-form-item>
								  	</el-col>
								</el-row>
							</el-form>
						</div>
				  	</div>
					<el-divider></el-divider>
				  	<!-- 配置信息 -->
				  	<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('privateNetInstance.configInfo') }}</h3>
						</div>
						<div class="jc-section-content">
						  	<el-form class="config-info-list">
								<el-row :gutter="20">
								  	<!--镜像-->
								  	<el-col :span="8">
										<el-form-item :label="$t('privateNetInstance.mirror') | withColon">
											{{ detail.osName }}
										</el-form-item>
								  	</el-col>
								  	<!--规格-->
								  	<el-col :span="8">
										<el-form-item :label="$t('privateNetInstance.spec') | withColon"
									 	class="edit-jc-form">
											<span :title="detail.spec" class="instance-name">{{ detail.spec }}</span>
										</el-form-item>
								  	</el-col>
								  	<!--CPU-->
								  	<el-col :span="8">
										<el-form-item :label="$t('create.text.cpu') | withColon">
										  {{ (detail.deviceInfo && detail.deviceInfo.cpuDetail) | maybeEmpty }}
										</el-form-item>
								  	</el-col>
								  	<!--内存-->
								  	<el-col :span="8">
										<el-form-item :label="$t('create.text.memory') | withColon">
										  <p class="english-word-wrap">{{ (detail.deviceInfo && detail.deviceInfo.memDetail) | maybeEmpty}}</p>
										</el-form-item>
								  	</el-col>
									<!-- 网卡 -->
									<el-col :span="8">
										<el-form-item :label="$t('create.text.netCard') | withColon">
										  <p>{{ detail.ifConcise | maybeEmpty}}</p>
										</el-form-item>
								  	</el-col>
								  	<!--系统盘-->
								  	<el-col :span="8">
										<el-form-item :label="$t('privateNetInstance.sysDisk') + ': '">
										  {{ detail.systemDiskDesc }}
										</el-form-item>
								  	</el-col>
								  	<!--数据盘-->
								  	<el-col :span="8">
										<el-form-item :label="$t('privateNetInstance.dataDisk') + ': '">
										  {{ detail.dataDiskDesc }}
										</el-form-item>
								  	</el-col>
								  	<!--GPU-->
								  	<el-col :span="8">
										<el-form-item :label="$t('create.text.gpu') | withColon">
										  <p>{{ detail.graphics | maybeEmpty}}</p>
										</el-form-item>
								  	</el-col>
								  	<!--初始密钥-->
								  	<el-col :span="8">
										<el-form-item :label="$t('privateNetInstance.initKeyPair') | withColon">
											<span :title="detail.keypairName" class="login-key">{{ detail.keypairName | maybeEmpty}}</span>
											<el-tooltip class="ml10" effect="dark" placement="right">
												<div slot="content" class="my-os-disk-tip">
												{{$t('privateNetInstance.initPairTip')}}
												</div>
												<a><i class="jc-icon-question"></i></a>
											</el-tooltip>
										</el-form-item>
								  	</el-col>
								  	<!--最近一次安装系统分区参数-->
								  	<el-col :span="24">
										<el-form-item :label="$t('create.text.lastCustomPartition') | withColon" 
											class="customPartition">
			                                <span v-if="detail.customSystemPartition">{{$t('create.text.sysDisk')}}</span>
			                                <span v-if="detail.customSystemPartition" v-html="detail.customSystemPartition"></span>
			                                <span v-if="detail.customDataPartition">{{$t('create.text.dataDisk')}}</span>
			                                <span v-if="detail.customDataPartition" v-html="detail.customDataPartition"></span>
			                                <span v-if="!detail.customSystemPartition && !detail.customDataPartition">{{detail.customSystemPartition | formatEmptyFilter}}</span>
										</el-form-item>
								  	</el-col>
								</el-row>
						  	</el-form>
						</div>
				  	</div>
					<el-divider></el-divider>
				  	<!-- 网络信息 -->
					<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('privateNetInstance.networkInfo') }}</h3>
						</div>
						<div class="jc-section-content">
						  	<el-form class="net-info-list">
								<el-row :gutter="20">
			
									<el-col :span="8">
										<el-form-item :label="$t('eip.text.internetAccessType')| withColon">
											<span>{{detail.interfaceMode==='dual'?$t('create.text.doubleInternetAccess'):$t('create.text.singleInternetAccess')}}</span>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item :label="$t('create.text.networkName') | withColon">
											<span>{{detail.interfaceMode==='dual'?$t('create.text.chiefAndSubInternetAccessName'):$t('create.text.singleInternetAccessChiefName')}}</span>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item :label="$t('detail.text.iloIp')| withColon">
											<span>{{detail.iloIp}}</span>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item :label="$t('detail.text.podName')| withColon">
											<span>{{detail.podName + ' (' + detail.podDescription + ')'}}</span>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<el-form-item :label="$t('privateNetInstance.fireWall') | withColon">
										  {{ $t('create.help.publicOpen') }}
										  <a :href="Config.FIRE_HELP_URL" target="_blank">
											<i class="jc-icon-enlarge"></i>
											{{ $t('privateNetInstance.operateGuid') }}
										  </a>
										</el-form-item>
								  	</el-col>
								</el-row>
						  	</el-form>
						</div>
						<!-- 主网口 -->
						<div class="jc-section-content">

							<h3 class="jc-section-head">{{detail.interfaceMode==='dual'?$t('create.text.chiefInternetAccessName'):$t('create.text.singleInternetAccessChiefName')}}
							</h3>
							<el-form class="net-info-list">
								<el-row :gutter="20">
								  	<el-col :span="8">
										<el-form-item :label="$t('privateNetInstance.networkType') | withColon">
										  <span>{{ $t('retailInstance.text.retailInstanceNet') }}</span>
										</el-form-item>
								  	</el-col>
									<el-col :span="8">
										<el-form-item :label="$t('detail.text.interNetIpv4') | withColon">
											<span>{{detail.privateIp}}</span>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
						<!-- 辅网口 -->
						<div class="jc-section-content" v-if="detail.interfaceMode==='dual'">
							<h3 class="jc-section-head">{{$t('create.text.subInternetAccessName')}}
							</h3>
							<el-form class="net-info-list">
								<el-row :gutter="20">
								  	<el-col :span="8">
										<el-form-item :label="$t('privateNetInstance.networkType') | withColon">
										  <span>{{ $t('retailInstance.text.retailInstanceNet') }}</span>
										</el-form-item>
								  	</el-col>
									<el-col :span="8">
										<el-form-item :label="$t('detail.text.interNetIpv4') | withColon">
											<span>{{detail.extensionPrivateIp}}</span>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
					</div>
				</el-tab-pane>
				<!-- tab:硬件监控 -->
				<el-tab-pane 
					:label="$t('privateNetInstance.hardWareMonitor')" 
					name="hardWareMonitor"
					:disabled="tabName==='hardWareMonitor'">
				  	<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('detail.text.hardwareStatusList') }}</h3>
						</div>
						<div class="jc-section-content">
							<hardware-status :hardWareData="hardWareData"></hardware-status>
						</div>
				  	</div>
				  	<div class="jc-section mt20">
						<div class="jc-section-header">
							<h3 class="jc-section-title">
								{{ $t('detail.text.warningLogList') }}
							</h3>
						</div>
						<div class="jc-section-content">
						  	<alarm-logs :eventLogs="infoLogData"></alarm-logs>
						</div>	
				  	</div>
					<div ref="footer" class="jc-page-footer-detail block jc-container-table-actionBar" v-if="total">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
						</el-pagination>
					</div>
				</el-tab-pane>
				<!-- tab:性能监控 -->
				<el-tab-pane 
					:label="$t('detail.text.performanceMonitor')" 
					name="performanceMonitor"
					:disabled="tabName==='performanceMonitor'">
					<router-view v-if="hasMonitor"></router-view>
				</el-tab-pane>
			</el-tabs>
			<open :visible.sync="openInstance"
				:name="detail.name"
				:instanceId="detail.instanceId"
				:region="detail.region"
				@refresh="operateRefresh">
			</open>
			<close :visible.sync="closeInstance"
				:name="detail.name"
				:region="detail.region"
				:instanceId="detail.instanceId"
				@refresh="operateRefresh">
			</close>
			<restart :visible.sync="restartInstance"
			   	:name="detail.name"
			   	:region="detail.region"
			   	:instanceId="detail.instanceId"
			   	@refresh="operateRefresh">
			</restart>
			<reset-password :dialogVisible.sync="resetPasswordDialogVisible" :detail-data="detail"
				@refreshData="operateRefresh">
			</reset-password>
			<reinstall 
				:visible.sync="reInstall"
				:rowInfo="detail"
				:retailTipChange="retailTipChange"
				instanceType="retail"
				@openReConfirm="openReConfirm"
				v-if="reInstall">
			</reinstall>
			<resys :visible.sync="reSysConfirm"
				:formInfo="reSysForm"
				:rowInfo="reSystemInfo"
				@refresh="operateRefresh"
				v-if="reSysConfirm">
			</resys>
		  	<jcb-opt-protect 
		  		:visible.sync="operationProtectVisible" 
		  		:action-type="actionType"
				@success="onSuccess"
				@error="onError">
		  	</jcb-opt-protect>
		  	<!--编辑标签-->
		  	<jcb-tag-edit :visible.sync="editTagDialogVisible"
				:service-code="ServiceCodeConstant.CPS"
				:region-id="detail.region !== undefined ? detail.region : ''"
				:resource-ids="detail.instanceId !== undefined ? [detail.instanceId] : []"
				@complete="showInstanceDetail(defaultParams)">
		  	</jcb-tag-edit>
		  	<!--删除实例-->
			<delete-instance 
				:visible.sync="deleteVisible"				
				:rowInfo="detail"
				:pageSource="'detail'"
				@goList="goBack"
				@refresh="operateRefresh">		
			</delete-instance>
			<!--开启实例删除操作保护-->
			<enable-deletion-protection
				:visible.sync="enableDeletionProtectionVisible"
				:instanceName="detail.name"
				:region="detail.region"
				:instanceId="detail.instanceId"
				@refresh="operateRefresh">
			</enable-deletion-protection>
			<!--关闭实例删除操作保护-->
			<disable-deletion-protection
				:visible.sync="disableDeletionProtectionVisible"
				:instanceName="detail.name"
				:region="detail.region"
				:instanceId="detail.instanceId"
				@refresh="operateRefresh">
			</disable-deletion-protection>
		</div>
  	</div>
</template>

<script>

import copyValue from '@/components/privateNetwork/CopyValue';
import editValue from '@/components/privateNetwork/EditValue';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import open from '@/components/privateNetInstance/operates/Open';
import close from '@/components/privateNetInstance/operates/Close';
import restart from '@/components/privateNetInstance/operates/Restart';
import repassword from '@/components/privateNetInstance/operates/Repassword';
import reinstall from '@/components/privateNetInstance/operates/ReSystem';
import resys from '@/components/privateNetInstance/operates/ReSysConfirm';
import { validateName } from '@/common/dataHelper';
import AgentStatus from '@/components/privateNetInstance/AgentStatus';
import ResetPassword from '@/components/common/resetPassword/ResetPassword';
import operationProtect from '@/mixins/operationProject';
import isDestroyingMixins from '@/mixins/isDestroying';
import DeleteInstance from '@/components/common/DeleteInstance';
import EnableDeletionProtection from '@/components/common/enableDeletionProtection/EnableDeletionProtection';
import DisableDeletionProtection from '@/components/common/disableDeletionProtection/DisableDeletionProtection';
import HardwareStatus from '@/components/common/hardwareStatus/HardwareStatus';
import AlarmLogs from '@/components/common/alarmLogs/AlarmLogs';

import { operations } from '@/common/EipPopHelper';
import {
	ServiceCodeConstant,
	OverdueConstantArray,
	ChargeModeConstant,
	DeleteProtectStatusConstant
} from "@/common/Constants";
import {deepCopy} from '@/common/tool';
export default {
  	name: 'RetailInstanceDetail',
  	components: {
		AgentStatus,
		copyValue,
		editValue,
		dropDownOperation,
		restart,
		reinstall,
		open,
		close,
		resys,
		ResetPassword,
		DeleteInstance,
		EnableDeletionProtection,
		DisableDeletionProtection,
		HardwareStatus,
		AlarmLogs
  	},
  	mixins:[operationProtect, isDestroyingMixins],
  	data() {
		const valName = (rule, value, callback) => {
			const reg = new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:]{1,127})$');
			if (!reg.test(value)) {
				callback(new Error(this.$t('create.help.instanceNameRule')));
			} else {
				callback();
			}
		};
		const valDes = (rule, value, callback) => {
		  	if (value.length > 256) {
				callback(new Error(this.$t('detail.speechCraft.descriptionLongRule')));
		  	} else {
				callback();
		  	}
		};
		return {
      statusTimeOut: null,
			showEditDes: false,
			showEditName: false,
			tabName: '',
			rules: {
				name: [
				  {
					required: true,
					message: this.$t('privateNetwork.nameNotNull'),
				  },
				  {
					validator: valName,
				  }
				],
				description: [
				  {
					validator: valDes,
				  }
				]
			},
			reSysConfirm: false,
			reSysForm: {},
			reSystemInfo: {},
			openInstance: false,
			closeInstance: false,
			restartInstance: false,
			repasswordInstance: false,
			reInstall: false,
			retailTipChange:'retail',
			pageSize: 20,
			pageSizes: [20, 50, 100], // 可选每页展示多少条
			total: 0,
			currentPage:1,
		  	operateMap: {
				stopped: [
				  'restart'
				],
				running: [
				  'reinstall',
				  'resetPassword',
				  'delete'
				],
				error: [
				  'start',
				  'turnOff',
				  'restart',
				  'resetPassword',
				  'reinstall',
				  'bandWidth',
				  'renew',
				  'editTag',
				  'turnOnDeleteProtect',
				  'turnOffDeleteProtect',				  
				  'delete',
				],
				creating: [
				  'start',
				  'turnOff',
				  'restart',
				  'resetPassword',
				  'reinstall',
				  'bandWidth',
				  'renew',
				  'editTag',
				  'turnOnDeleteProtect',
				  'turnOffDeleteProtect',				  
				  'delete',
				],
				upgrading: [
				  'start',
				  'turnOff',
				  'restart',
				  'resetPassword',
				  'reinstall',
				  'bandWidth',
				  'renew',
				  'editTag',
				  'turnOnDeleteProtect',
				  'turnOffDeleteProtect',				  
				  'delete',
				],
				destroying: [
				  'start',
				  'turnOff',
				  'restart',
				  'resetPassword',
				  'reinstall',
				  'bandWidth',
				  'renew',
				  'editTag',
				  'turnOnDeleteProtect',
				  'turnOffDeleteProtect',				  
				  'delete',
				],
				other: [
				  'start',
				  'turnOff',
				  'restart',
				  'resetPassword',
				  'reinstall',
				  'bandWidth',
				  'editTag',
				  // 'renew'
				  'turnOnDeleteProtect',
				  'turnOffDeleteProtect',
				  	'delete',
				],
				noOperate: [
				  'starting',
				  'running',
				  'stopping',
				  'stopped',
				  'error',
				  'restarting',
				  'creating',
				  'destroying',
				  'upgrading',
				  'reinstalling',
				  'turnOnDeleteProtect',
				  'turnOffDeleteProtect',
				  'delete',
				]
		  	},
			statusListMap: {
				'starting': 'other',
				'running': 'running',
				'stopping': 'other',
				'stopped': 'stopped',
				'error': 'error',
				'restarting': 'other',
				'creating': 'creating',
				'destroying': 'destroying',
				'upgrading': 'upgrading',
				'reinstalling': 'other',
				'noOprate': 'noOperate',
				'other': 'other',
				'resetting_password': 'other',
			},
			interStatus: [
				'creating',
				'starting',
				'stopping',
				'restarting',
				'upgrading',
				'reinstalling',
				'destroying',
				'resetting_password'
			],
			statusMapName: {
				'creating': this.$t('privateNetInstance.statueNames.creating'),
				'starting': this.$t('privateNetInstance.statueNames.starting'),
				'running': this.$t('privateNetInstance.statueNames.running'),
				'stopping': this.$t('privateNetInstance.statueNames.stopping'),
				'stopped': this.$t('privateNetInstance.statueNames.stopped'),
				'restarting': this.$t('privateNetInstance.statueNames.restarting'),
				'error': this.$t('privateNetInstance.statueNames.error'),
				'upgrading': this.$t('privateNetInstance.statueNames.upgrading'),
				'reinstalling': this.$t('privateNetInstance.statueNames.reinstalling'),
				'destroying': this.$t('privateNetInstance.statueNames.destroying'),
				'resetting_password' :this.$t('listPage.text.resettingPassword') ,
			},
			renew: false,
			detail: {},
			operations: [],
			hardWareData: [],
			infoLogData: [],
			defaultParams: '',
			ops: [],
			instanceId: '',
			region: '',
			// 给操作保护用区分物理机类型：basic/vpc
			instanceType: 'vpc',
			// 重装密码弹框是否可见
			resetPasswordDialogVisible: false,
			// 存储region和regionName
			regions: {},
			// 编辑标签组件是否显示
			editTagDialogVisible: false,
			// 批量编辑标签组件是否显示
			batchEditTagDialogVisible: true,
			// 删除实例弹框
			deleteVisible: false,
			// 硬件监控loading
			hasMonitor: false,
			// 开启实例删除操作保护弹框
			enableDeletionProtectionVisible: false,
			// 关闭实例删除操作保护弹框
			disableDeletionProtectionVisible: false,
		};
  	},
  	computed: {
		OverdueConstantArray: () => OverdueConstantArray,
		ServiceCodeConstant: () => ServiceCodeConstant,
		ChargeModeConstant: () => ChargeModeConstant,
		DeleteProtectStatusConstant: () => DeleteProtectStatusConstant
  	},
  	watch: {
	  '$route' (to, from) {
			this.tabName = this.$route.query.tabName;
	 	}
	},
	created() {
		const region = this.$route.query.region;
		const id = this.$route.query.id;
		const az = this.$route.query.az;
		this.tabName = this.$route.query.tabName;
		this.instanceId = id;
		this.region = region;
		const params = {
			region,
			instanceId: id,
			az,
		};
		this.defaultParams = params;
		this.showInstanceDetail(params);
		this.getRegionNames();
		if (this.tabName === 'performanceMonitor') {
			this.hasMonitor = true;
		}
	},
  destroyed() {
        clearTimeout(this.statusTimeOut)
    },
  	methods: {
		/**
		 * 点击跳转初始密钥详情
		 * @param keyPairId
		 * @param region
		*/
		jumpToKeyPairDetail(keypairId, region) {
			this.$router.push({
			  	path: '/ssh/detail',
				query: {
					id: keypairId,
					region
				}
			});
		},
		/**
		 * 获得region和regionName对照
		*/
		getRegionNames() {
			const params = {
				networkType: 'retail'
			};
		  	Ajax.get('api/cps/getRegions', params).then((res) => {
				if (res.data) {
				  	res.data.regions.forEach((region) => {
						this.regions[region.region] = region.regionName;
						region.azs.forEach((az) => {
							this.regions[az.az] = az.azName;
						})
				  	});
				}
		  	});
		},
		// 切换顶部资源信息、硬件监控、网口详情等tab
		changeTab(tab) {
			this.hasMonitor = false;
			if (tab.name === 'hardWareMonitor') {
				const params = {
					instanceId: this.instanceId,
					region: this.region,
					sn: this.sn
				};
				this.getDescribeInstanceStatus(params);
				this.getDescribeEventLog(params)
			} else if(tab.name === 'performanceMonitor') {
				this.hasMonitor = true;
				let query = this.$route.query;
				query.tabName = 'performanceMonitor'
				this.$router.push({
					path: `${this.$route.path.replace(/\/performance/g, '')}/performance`,
					query: {
						...query,
						imageType: this.detail.imageType
				  	}
			  	});
			}
		},
		openReConfirm(formInfo, rowInfo) {
			this.reSysForm = formInfo;
			this.reSystemInfo = rowInfo;
			this.reSysConfirm = true;
		},
		operateRefresh() {
			const params = {
				region: this.detail.region,
				instanceId: this.detail.instanceId,
				az: this.detail.az,
			};
			this.defaultParams = params;
			this.showInstanceDetail(params);
		},
		afterOperateBind() {
			this.operateRefresh();
		},
		clickOperate(item) {
			switch (item) {
				case 'rePassword':
					Pop.resetPassword(this, this.detail);
					break;
				case 'repay':
					this.renewInstance(this.detail.instanceId);
					break;
				case 'reInstall':
					this.reInstall = true;
					break;
				case 'open':
					Pop.vpcInstance_open(this, this.detail, 'detail');
					break;
				case 'close':
					Pop.vpcInstance_close(this, this.detail, 'detail');
					break;
				case 'restart':
					Pop.vpcInstace_restart(this, this.detail, 'detail');
					break;
				case 'editTag':
					this.editTagDialogVisible = true;
					break;
				case 'delete':
					this.deleteVisible = true;
					break;
				case 'turnOnDeleteProtect':
					this.enableDeletionProtectionVisible = true;
					break;
				case 'turnOffDeleteProtect':
					this.disableDeletionProtectionVisible = true;					
				default:
					break;
			}
		},
		renewInstance(id) {
			const params = {
				resourceId: id,
				region: this.detail.region,
				serviceCode: ServiceCodeConstant.CPS
			};
		  	Ajax.get('/api/order/submitRenew', params)
			.then((res) => {
				const tempOrderId = res.data.tmpOrderId;
				window.location.href = `${this.Config.RENEW_CONSOLE_URL}/orderConfirmPageIp?requestId=${tempOrderId}&resourceType=cps`;
			});
		},
		goBack() {
		  	this.$router.push({
				path: '/instance/retail/list',
				query: {
				  	region: this.detail.region
				}
		  	});
		},
		showInstanceDetail(params) {
      if (this.isDestroying) {
          return
      }
			this.getInstanceDetail(params).then(() => {
				if (this.interStatus.includes(this.detail.status)) {
					clearTimeout(this.statusTimeOut);
          this.statusTimeOut =setTimeout(() => {
						this.showInstanceDetail(params)
					}, 5000);
				}
			}).catch(async (err) => {
			  	const { response } = err.data;
			  	try {
					const json = await response.json();
					this.$message.error(json.errmsg);
			  	} catch (e) {
					console.log(e);
			  	}
			});
		},
		getInstanceDetail(params) {
			this.renew = false;
		  	return Ajax.get('/api/cps/getInstanceInfo', params)
			.then((res) => {
				if (res.data) {
					this.detail = res.data.instance;
					// 获取sn
					this.sn = this.detail.sn;
					// 显卡信息
					this.detail.graphics = res.data.instance.cpsConfiguration.deviceType.gpuConcise;
					// deviceInformation
					this.detail.deviceInfo = res.data.instance.cpsConfiguration.deviceType;
					this.detail.ifConcise = this.detail.deviceInfo.ifConcise;
					this.detail.chargeMode = res.data.instance.charge.chargeMode;
					// 登录密钥对特殊处理
					this.detail.keypairName = res.data.instance.keypairName && res.data.instance.keypairName.join(' | ');
					// 格式化标签键值对
					const tagPairs = res.data.instance.tags;
					this.detail.tagPairs = ''
					if(tagPairs !== undefined){
					  	if (tagPairs.length > 0) {
							for (const tag of tagPairs) {
								this.detail.tagPairs += `${tag.key}:${tag.value},`;
							}
							this.detail.tagPairs = this.detail.tagPairs.substring(0, this.detail.tagPairs.length - 1)
					  	}
					}
					this.dealCustomPartition(this.detail.customPartition);
					this.ops = this.initOperations(this.detail);
				}
			}).catch(async (err) => {
			  	this.detail = {};
			  	const { response } = err.data;
			  	try {
					const json = await response.json();
					this.$message.error(json.errmsg);
			  	} catch (e) {
					console.log(e);
			  	}
			});
		},
		// 最近一次安装系统分区参数处理
		dealCustomPartition(customPartition) {
            let customSystemPartition = this.partitionsFormatter(customPartition.systemDiskPartitions);
            let customDataPartition = this.partitionsFormatter(customPartition.dataDiskPartitions);
            this.detail.customSystemPartition = customSystemPartition;
            this.detail.customDataPartition = customDataPartition;
		},

		// 格式化分区信息
		partitionsFormatter(partitions) {
            return partitions.reduce((init,current) =>{
                let size;
                if (current.size === 999999999) {
                    size = this.$t('retailInstance.text.allRemainingSpace');
                } else {
                    size = current.size / 1024 + 'GiB';
                }
                return `${init}<strong class="ml5 mr5">${current.point}:</strong>${size},${current.format};` 
            },'');
        },
		// 获取硬件设备状态列表
		getDescribeInstanceStatus(params) {
			this.hardWareData = [];
		 	Ajax.get('/api/cps/describeInstanceStatus', params)
			.then((res) => {
			  	this.hardWareData.push(
	              	{
	                	name: 'CPU',
	                	status: res.data.cpus
	              	},
	              	{
	                	name: this.$t('detail.text.memory'),
	                	status: res.data.mems
	              	},
	              	{
	                	name: this.$t('detail.text.hardDisk'),
	                	status: res.data.disks
	              	},
	              	{
	                	name: this.$t('detail.text.netCard'),
	                	status: res.data.nics
	              	},
	              	{
	                	name: this.$t('detail.text.power'),
	                	status: res.data.powerStatus
	              	},
	              	{
	                	name: this.$t('detail.text.other'),
	                	status: res.data.otherStatus
	              	},
			  	);
			}).catch(err => {
				const { response } = err.data;
				try {
					const json = response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			});
		},
		// 获取报警日志列表
		getDescribeEventLog(params) {
		  	Ajax.get('/api/cps/oob/listDeviceAlertLog', params)
			.then((res) => {
				this.infoLogData = res.data && res.data.list;
				this.total = res.data.list.length;
			}).catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			});
		},
		handleSizeChange(val) {
			this.pageSize = val;
			const param = {
				instanceId: this.instanceId,
				region: this.region,
				pageSize: this.pageSize,
				sn: this.sn,
			};			
			this.getDescribeEventLog(param);
		},

		handleCurrentChange(val) {
			this.currentPage = val;
			const param = {
				instanceId: this.instanceId,
				region: this.region,
				pageSize: this.pageSize,
				sn: this.sn,
			};	
			this.getDescribeEventLog(param);
		},
		// 编辑名称
		editName(value) {
			this.renew = false;
			const params = {
				region: this.detail.region,
				instanceId: this.detail.instanceId,
				name: value
			};
		  	Ajax.post('/api/cps/modifyInstanceName', params)
			.then((res) => {
				if (res.data) {
					this.detail.name = res.data.name;
				}
			}).finally(() => {
				this.renew = true;
			});
		},
		// 编辑描述
		editDes(value) {
			this.renew = false;
			const params = {
				region: this.detail.region,
				instanceId: this.detail.instanceId,
				description: value
			};
		  	Ajax.post('/api/cps/modifyInstanceDescription', params)
			.then((res) => {
				if (res.data) {
					this.detail.description = res.data.description;
				}
			})
			.finally(() => {
				this.renew = true;
			});
		},
		transformChargeMode(type) {
			switch (type) {
				case 'postpaid_by_duration':
					return this.$t('listPage.text.postpaid_by_duration');
					break;
				default:
					return this.$t('privateNetInstance.monthAndYear');
					break;
			}
		},
		getClassByStatue(statue) {
			switch (statue) {
				case 'running':
				  return ['jc-status-success'];
				case 'error':
				  return ['my-error-status', 'jc-status-danger'];
				case 'stopped':
				  return ['jc-status-warning'];
				default:
				  return ['jc-status', 'my-status', 'my-status-middle','mt12'];
			}
		},
		transFormStatusName(status) {
			return this.statusMapName[status];
		},
		initOperations() {
		  	const item = this.detail;
		  	const operations = [
				{
				  operateName: this.$t('privateNetInstance.restart'),
				  disabled: OverdueConstantArray.includes(item.charge.chargeStatus)
					|| this.operateMap[this.statusListMap[item.status]].indexOf('restart') > -1
					|| !item.charge.chargeStatus,
				  tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') 
				  		: OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') 
						: this.$t('privateNetInstance.operations.onlyRunning'),
				  value: 'restart'
				},
				{
				  operateName: this.$t('privateNetInstance.operations.rePassword'),
				  disabled: this.operateMap[this.statusListMap[item.status]].indexOf('resetPassword') !== -1
					|| OverdueConstantArray.includes(item.charge.chargeStatus)
					|| !item.charge.chargeStatus,
				  tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') 
				  		: OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') 
						: this.$t('privateNetInstance.operations.onlyShutDown'),
				  value: 'rePassword'
				},
				{
				  operateName: this.$t('privateNetInstance.operations.reOperateSystem'),
				  disabled: this.operateMap[this.statusListMap[item.status]].indexOf('reinstall') > -1
					|| OverdueConstantArray.includes(item.charge.chargeStatus)
					|| !item.charge.chargeStatus,
				  tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') 
				  		: OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') 
						: this.$t('privateNetInstance.operations.onlyShutDown'),
				  value: 'reInstall'
				},
				{
				  operateName: this.$t('privateNetInstance.operations.repay'),
				  disabled: this.operateMap[this.statusListMap[item.status]].indexOf('renew') > -1
					|| !item.charge.chargeStatus,
				  tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') 
				  		: '',
				  value: 'repay'
				}
		  	];
		  	if (item.status === 'stopped') {
				operations.splice(0, 0, {
					operateName: this.$t('privateNetInstance.open'),
					disabled: OverdueConstantArray.includes(item.charge.chargeStatus)
					|| this.operateMap[this.statusListMap[item.status]].indexOf('start') > -1
					|| !item.charge.chargeStatus,
					tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') 
				  		: OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') 
						: this.$t('privateNetInstance.operations.onlyShutDown'),
					value: 'open'
				});
		  	} else {
				operations.splice(0, 0, {
					operateName: this.$t('privateNetInstance.shutdown'),
					disabled: OverdueConstantArray.includes(item.charge.chargeStatus)
					|| this.operateMap[this.statusListMap[item.status]].indexOf('turnOff') > -1
					|| !item.charge.chargeStatus,
					tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') 
				  		: OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') 
						: this.$t('privateNetInstance.operations.onlyRunning'),
					value: 'close'
				});
		  	}
		  	// 编辑标签
		 	operations.push({
				operateName: this.$t('operations.edit_tag.name'),
				disabled: this.operateMap[this.statusListMap[item.status]].indexOf('editTag') > -1
				|| OverdueConstantArray.includes(item.charge.chargeStatus)
				|| !item.charge.chargeStatus,
				tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') 
				  		: OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') 
						: this.$t('operations.edit_tag.tip'),
				value: 'editTag'
		  	});
		  	// 开启实例删除保护
			if (item.removeProtect === 'no') {
				const turnOnDeleteProtect = {
					operateName: this.$t('operations.turnOnDeleteProtect.name'),
					disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
					|| !item.charge.chargeStatus
					|| this.operateMap[this.statusListMap[item.status]].indexOf('turnOnDeleteProtect') > -1
					|| this.instanceByConfigOpesDisabled(item),
					value: 'turnOnDeleteProtect',
					tip: ''
				};
				if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
		        	turnOnDeleteProtect.tip = this.$t('operations.turnOnDeleteProtect.prepaidTip')
		        }
		        if (this.instanceByConfigOpesDisabled(item)) {
		        	turnOnDeleteProtect.tip = this.$t('operations.turnOnDeleteProtect.tip')
		        }
				if (!item.charge.chargeStatus) {
					turnOnDeleteProtect.tip = this.$t('eip.help.noChargeInfo')
				}
		        operations.push(turnOnDeleteProtect);
			}
			// 关闭实例删除保护
			if (item.removeProtect === 'yes') {
		        const turnOffDeleteProtect = {
					operateName: this.$t('operations.turnOffDeleteProtect.name'),
					disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
					|| !item.charge.chargeStatus
					|| this.operateMap[this.statusListMap[item.status]].indexOf('turnOffDeleteProtect') > -1
					|| this.instanceByConfigOpesDisabled(item),
					value: 'turnOffDeleteProtect',
					tip: ''
				};
				if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
		        	turnOffDeleteProtect.tip = this.$t('operations.turnOnDeleteProtect.prepaidTip')
		        }
		        if (this.instanceByConfigOpesDisabled(item)) {
		        	turnOffDeleteProtect.tip = this.$t('operations.turnOffDeleteProtect.tip')
		        }
				if (!item.charge.chargeStatus) {
					turnOffDeleteProtect.tip = this.$t('eip.help.noChargeInfo')
				}
		        operations.push(turnOffDeleteProtect);
			}
		  	// 删除实例
	        const deleteOperate = {
				operateName: this.$t('operations.delete.name'),
				disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
				|| !item.charge.chargeStatus
				|| this.operateMap[this.statusListMap[item.status]].indexOf('delete') > -1
				|| item.status === 'stopped' && !!item.ipv6AddressId
				|| item.removeProtect === 'yes',
				value: 'delete',
				tip: ''
	        };
	        if (item.removeProtect === 'yes') {
		       	deleteOperate.tip = this.$t('operations.delete.tipWithRemoveProtect')
		    }
		   	if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
	        	deleteOperate.tip = this.$t('operations.delete.tip')
	        }
			if (this.operateMap[this.statusListMap[item.status]].indexOf('delete') > -1) {
				deleteOperate.tip = this.$t('operations.delete.tipWithStatus');
			}
			if (!item.charge.chargeStatus) {
				deleteOperate.tip = this.$t('eip.help.noChargeInfo')
			}
	        operations.push(deleteOperate);
		  	return operations;
		},
		/**
			* 当按配置购买的实例处于欠费状态时
			* 除删除操作外，其余操作置灰
			* @param item
			* @return {boolean}
		*/
		instanceByConfigOpesDisabled(item) {
			return item.charge.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION
				&& OverdueConstantArray.includes(item.charge.chargeStatus);
		},

		selectOpts(caseOps, cps, operate, disabled, otherDisabled) {
			if (disabled) {
				return;
			}
		  	operations(caseOps, this, cps, 'detail');
		},
  	},
};
</script>

<style lang="scss">
  @import "../../../assets/scss/detailCommon.scss";
  @import "instanceDetail";
</style>



// WEBPACK FOOTER //
// src/views/retailInstance/detail/RetailInstanceDetail.vue